import React, { useState, useEffect } from "react";
import "./Slider.css";

const AutoSlider = ({ language }) => {
  const [slideIndex, setSlideIndex] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setSlideIndex((prevIndex) => (prevIndex + 1) % slides.length);
    }, 3000);
    return () => clearInterval(intervalId);
  }, []);

  const slides = [
    <h1 style={{ padding: "30px" }}>{language.recomendation_one}</h1>,
    <h1 style={{ padding: "30px" }}>{language.recomendation_two}</h1>,
    <h1 style={{ padding: "30px" }}>{language.recomendation_one}</h1>,
  ];

  return (
    <div>
      <h1 style={{ color: "black", textAlign: "center" }}>
        {language.recomendations}
      </h1>
      <div className="slider">{slides[slideIndex]}</div>
    </div>
  );
};

export default AutoSlider;
